import { type PublicKudoContentObject, createPublicKudoContentObject } from 'models';
import { type UseQueryOptions, useQuery } from 'query';
import type { ApiClientResponseError, ResponseErrorDataObject } from 'common/services';
import { getPublicKudo } from '../../services';
import { getPublicContentObjectDetailQueryKey } from '../keys';

export const usePublicKudoQuery = (
  id: string,
  queryOptions?: Omit<
    UseQueryOptions<PublicKudoContentObject, ApiClientResponseError<ResponseErrorDataObject>>,
    'queryFn' | 'queryKey'
  >,
) =>
  useQuery<PublicKudoContentObject>({
    async queryFn() {
      const { data } = await getPublicKudo({ routeParams: { id } });
      return createPublicKudoContentObject(data);
    },
    queryKey: getPublicContentObjectDetailQueryKey({ id }),
    ...queryOptions,
  });
